import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Instrument_Check_Form.css";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateIntermediateEquipment,
  CreateIntrumentEquipment,
} from "../../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";
import { AllPermissionDropdown } from "../../../../../../../../features/admin/common/Slice";
import { FixIDS } from "../../../../../../../../utils/fixIDS";

function Instrument_Check_Form({ onProceed, all_instruments, fetchCustomers }) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      instrument_id: null,
      instrument_unique_id: "",
      calibrate_instrument: "",
      from_date: "",
      to_date: "",
      next_date: "",
      remark: "",
    },
  });

  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("user_id", data?.user_id?.value);
      sendData.append("instrument_id", data?.instrument_id?.value);
      if (data?.from_date) {
        sendData.append("from_date", data?.from_date);
      }
      sendData.append("remark", data?.remark);
      if (data?.next_date) {
        sendData.append("next_date", data?.next_date);
      }
      if (data?.to_date) {
        sendData.append("to_date", data?.to_date);
      }

      const res = await dispatch(CreateIntrumentEquipment({ data: sendData }));
      if (res.meta?.requestStatus === "fulfilled") {
        await fetchCustomers();
        // dispatch(GetAll({ page: 1, per_page: 10 }));
        setSuccess(true);
        reset();
        setTimeout(() => {
          setSuccess(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };
  const allPermissionDropdown = useSelector(
    (state) => state.common.all_permission_dropdown,
  );
  useEffect(() => {
    dispatch(
      AllPermissionDropdown({ permission_id: FixIDS.instrument_check.List }),
    );
  }, [dispatch]);

  console.log(errors, "errors");

  return (
    <section className="Legal_Entity_Form">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="white_container customer_section">
          <div className="row">
            {/* Instrument */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Instrument</Form.Label>
                <Controller
                  name="instrument_id"
                  control={control}
                  rules={{ required: "Instrument is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_instruments}
                      placeholder="Select Instrument"
                      classNamePrefix="react_select"
                      value={field.value || null} // ✅ FIX HERE
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption); // ✅ important

                        setValue(
                          "instrument_unique_id",
                          selectedOption?.data?.unique_id || "",
                        );

                        setValue(
                          "calibrate_instrument",
                          selectedOption?.data?.User?.name || "",
                        );
                      }}
                    />
                  )}
                />

                {errors.instrument_id && (
                  <Form.Text className="text-danger">
                    {errors.instrument_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Instrument ID</Form.Label>
                <Form.Control
                  readOnly
                  placeholder="Instrument ID"
                  {...register("instrument_unique_id", {
                    // required: "Instrument ID is required",
                  })}
                />

                {errors.instrument_unique_id && (
                  <Form.Text className="text-danger">
                    {errors.instrument_unique_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Check By</Form.Label>
                <Controller
                  className="select-contoller"
                  name={`user_id`} // name of the field
                  control={control}
                  rules={{
                    required: "Select Check",
                  }}
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors?.user_id
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                      }}
                      options={allPermissionDropdown}
                      onBlur={onBlur}
                      value={value}
                      ref={ref}
                      onChange={(selectedValue) => {
                        onChange(selectedValue);
                      }}
                    />
                  )}
                />

                {errors.user_id && (
                  <Form.Text className="text-danger">
                    {errors.user_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            {/* <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Check By</Form.Label>
                <Form.Control
                  readOnly
                  placeholder="Enter Check By"
                  {...register("calibrate_instrument", {
                    // required: "Calibration value is required",
                  })}
                />

                {errors.calibrate_instrument && (
                  <Form.Text className="text-danger">
                    {errors.calibrate_instrument.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div> */}

            {/* Break Down */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Break Down</Form.Label>
                <div className="d-flex gap-2">
                  <Form.Control
                    type="date"
                    placeholder="From : DD/MM/YYYY"
                    {...register("from_date", {
                      // required: "From date is required",
                      // validate: (value) => {
                      //   const year = value.split("-")[0];
                      //   if (year.length !== 4) {
                      //     return "Year must be exactly 4 digits";
                      //   }
                      //   const selectedDate = new Date(value);
                      //   const today = new Date();
                      //   today.setHours(0, 0, 0, 0);
                      //   if (selectedDate < today) {
                      //     return "Past dates are not allowed";
                      //   }
                      //   return true;
                      // },
                    })}
                    onChange={(e) => {
                      let value = e.target.value;
                      const parts = value.split("-");

                      if (parts[0] && parts[0].length > 4) {
                        parts[0] = parts[0].slice(0, 4);
                        e.target.value = parts.join("-");
                      }
                    }}
                  />
                  <Form.Control
                    type="date"
                    placeholder="To : DD/MM/YYYY"
                    {...register("to_date", {
                      // required: "To Date is required",
                      // validate: (value) => {
                      //   const year = value.split("-")[0];
                      //   if (year.length !== 4) {
                      //     return "Year must be exactly 4 digits";
                      //   }
                      //   const selectedDate = new Date(value);
                      //   const today = new Date();
                      //   today.setHours(0, 0, 0, 0);
                      //   if (selectedDate < today) {
                      //     return "Past dates are not allowed";
                      //   }
                      //   return true;
                      // },
                    })}
                    onChange={(e) => {
                      let value = e.target.value;
                      const parts = value.split("-");

                      if (parts[0] && parts[0].length > 4) {
                        parts[0] = parts[0].slice(0, 4);
                        e.target.value = parts.join("-");
                      }
                    }}
                  />
                </div>
              </Form.Group>
            </div>

            {/* Next Due On */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Next Due On</Form.Label>
                <Form.Control
                  min={new Date().toISOString().split("T")[0]}
                  type="date"
                  placeholder="To : DD/MM/YYYY"
                  {...register("next_date", {
                    // required: "Next Due On is required",
                    // validate: (value) => {
                    //   const year = value.split("-")[0];
                    //   if (year.length !== 4) {
                    //     return "Year must be exactly 4 digits";
                    //   }
                    //   const selectedDate = new Date(value);
                    //   const today = new Date();
                    //   today.setHours(0, 0, 0, 0);
                    //   if (selectedDate < today) {
                    //     return "Past dates are not allowed";
                    //   }
                    //   return true;
                    // },
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark</Form.Label>

                <Form.Control
                  placeholder="Remark"
                  {...register("remark", {
                    required: "Remark is required",
                  })}
                />

                {errors.remark && (
                  <Form.Text className="text-danger">
                    {errors.remark.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="permission_btn_holder">
            <Button
              className="permission_btn No_btn"
              onClick={() =>
                reset({
                  instrument_id: null,
                  instrument_unique_id: "",
                  calibrate_instrument: "",
                  from_date: "",
                  to_date: "",
                  next_date: "",
                  remark: "",
                })
              }
            >
              Reset
            </Button>
            <Button
              className="permission_btn Yes_btn"
              // onClick={onProceed}
              type="submit"
            >
              Save
            </Button>
          </div>
        </div>
      </Form>

      {success && <Success_Toster successText="Instrument Add Successfully!" />}
    </section>
  );
}

export default Instrument_Check_Form;
